/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import L from 'leaflet';
import { Marker, Popup, Tooltip, useMap } from 'react-leaflet';

import { useDispatch, useSelector } from 'react-redux';

import { setSelectedRestaurant as storeSelectedRestaurant } from '../../../redux/legacy/reducers/ducks/legacy/RestaurantsDuck';
import {
  setCenterOnCarousel,
  setRestaurantCenter,
} from '../../../redux/legacy/reducers/ducks/legacy/MainDuck';

import styles from './MapMarkers.style';
import useClasses from '../../../hooks/legacy/useClasses';
import RestaurantCard from '../RestaurantCard';

import ClickedRestaurantPin from '../../../assets/images/icons/Pin1.svg';
import RestaurantPinfrom from '../../../assets/images/icons/Pin2.svg';
import useDesktopCheck from '../../../util/hooks/UseDesktopCheck';

import { useRestaurant } from '../../../hooks/useRestaurant';

function MapMarkers({
  list,
  center,
  restaurantCenter,
  isFullScreen,
  restaurantLandingPage,
}) {
  const map = useMap();
  const classes = useClasses(styles);
  const dispatch = useDispatch();
  const [clicked, setClicked] = useState();
  const isDesktop = useDesktopCheck();
  const { setSelectedRestaurant } = useRestaurant();

  const eventHandlers = {
    click(e) {
      const { id } = e.target.options;
      dispatch(setCenterOnCarousel(id));
      dispatch(setRestaurantCenter(id));
      setClicked(id);
    },
  };

  const { orderType } = useSelector(({ order }) => ({
    orderType: order?.type,
  }));

  useEffect(() => {
    if (center?.length) {
      map.panTo(center);
    }
  }, [center, map]);

  useEffect(() => {
    const bounds = list.map((marker) => [
      marker.location?.latitude,
      marker.location?.longitude,
    ]);
    const markerCenter = list.find(
      (marker) => marker.profile === restaurantCenter
    );

    const marker = markerCenter && [
      [markerCenter.location?.latitude, markerCenter.location?.longitude],
    ];

    if (bounds.length > 0) map.fitBounds(markerCenter ? marker : bounds);
  }, [map, list, restaurantCenter]);

  function GetIcon(_iconSize, profile) {
    return L.icon({
      iconUrl: profile === clicked ? ClickedRestaurantPin : RestaurantPinfrom,
      iconSize: [_iconSize],
    });
  }

  const onRestaurantClick = (id) => {
    // deprecated, use hook instead
    dispatch(storeSelectedRestaurant(id));
    // using the hook to update selected restaurant
    setSelectedRestaurant(id);
  };

  return list.map(
    (val, i) =>
      val.location?.latitude && (
        <Marker
          key={restaurantLandingPage ? val.id : val.profile}
          marker_index={i}
          icon={
            restaurantLandingPage
              ? GetIcon(25, val.id)
              : GetIcon(25, val.profile)
          }
          position={[val.location?.latitude, val.location?.longitude]}
          eventHandlers={eventHandlers}
          riseOffset={4}
          id={restaurantLandingPage ? val.id : val.profile}
          className={classes.marker}
        >
          {!isFullScreen && !restaurantLandingPage && (
            <Popup className={classes.popUp} minWidth={isDesktop ? 310 : 343}>
              <RestaurantCard
                data={val}
                onRestaurantClick={onRestaurantClick}
                isMapOpen={false}
                variant="map-popUp"
                orderType={orderType}
              />
            </Popup>
          )}

          <Tooltip
            className={classes.markerTooltip}
            direction="bottom"
            permanent
            offset={[0, 30]}
            opacity={1}
          >
            <div data-test-id="pin" className={classes.pinTitle}>
              {val.name}
            </div>
          </Tooltip>
        </Marker>
      )
  );
}

MapMarkers.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      categories: PropTypes.arrayOf(PropTypes.string),
      city: PropTypes.string,
      delays: PropTypes.shape({
        takeout: PropTypes.number,
        delivery: PropTypes.number,
      }),
      description: PropTypes.string,
      distance: PropTypes.number,
      features: PropTypes.arrayOf(PropTypes.string),
      fees: PropTypes.arrayOf(PropTypes.string),
      id: PropTypes.number,
      keywords: PropTypes.arrayOf(PropTypes.string),
      location: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
      }),
      media: PropTypes.oneOfType([
        PropTypes.objectOf(PropTypes.string),
        PropTypes.arrayOf(PropTypes.string),
      ]),
      modes: PropTypes.shape({
        delivery: PropTypes.bool,
        reservations: PropTypes.bool,
        takeout: PropTypes.bool,
      }),
      name: PropTypes.string,
      phone: PropTypes.string,
      profile: PropTypes.string,
      state: PropTypes.string,
      text: PropTypes.objectOf(PropTypes.string),
      windows: PropTypes.shape({
        takeout: PropTypes.number,
        delivery: PropTypes.number,
      }),
      zipcode: PropTypes.string,
    })
  ).isRequired,
  center: PropTypes.arrayOf(PropTypes.number),
  restaurantCenter: PropTypes.string,
  isFullScreen: PropTypes.bool,
  restaurantLandingPage: PropTypes.bool,
};

MapMarkers.defaultProps = {
  restaurantCenter: null,
  isFullScreen: false,
  restaurantLandingPage: false,
};

export default MapMarkers;
